var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 20.0002H7.1C5.18 20.0002 4.25 19.0202 4.25 17.0202V15.9802C4.25 13.9802 5.18 13.0002 7.1 13.0002H18.9C19.31 13.0002 19.65 13.3402 19.65 13.7502C19.65 14.1602 19.31 14.5002 18.9 14.5002H7.1C6.09 14.5002 5.75 14.7102 5.75 15.9802V17.0202C5.75 18.2902 6.09 18.5002 7.1 18.5002H18.9C19.31 18.5002 19.65 18.8402 19.65 19.2502C19.65 19.6602 19.31 20.0002 18.9 20.0002Z",
    fill: "#0C1525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 11.5002H12.1C10.18 11.5002 9.25 10.5202 9.25 8.52024V7.48023C9.25 5.47023 10.18 4.50023 12.1 4.50023H18.9C19.31 4.50023 19.65 4.84023 19.65 5.25023C19.65 5.66023 19.31 6.00023 18.9 6.00023H12.1C11.09 6.00023 10.75 6.21023 10.75 7.48023V8.52024C10.75 9.79024 11.09 10.0002 12.1 10.0002H18.9C19.31 10.0002 19.65 10.3402 19.65 10.7502C19.65 11.1602 19.31 11.5002 18.9 11.5002Z",
    fill: "#0C1525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.7402C18.59 22.7402 18.25 22.4002 18.25 21.9902V1.99023C18.25 1.58023 18.59 1.24023 19 1.24023C19.41 1.24023 19.75 1.58023 19.75 1.99023V21.9902C19.75 22.4002 19.41 22.7402 19 22.7402Z",
    fill: "#0C1525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/align-right.fa3ec83a4c89421108bae1e966c9ae11.svg";
export { ForwardRef as ReactComponent };